const processValue = (value: number) => {
  if (value > 255) return 255
  if (value < 0) return 0
  return value
}

const lightenDarkenColor = (colorCode: string, amount: number) => {
  const usePound = colorCode[0] === `#`
  const colorCodeWithoutPound = usePound ? colorCode.slice(1) : colorCode

  const num = parseInt(colorCodeWithoutPound, 16)
  // eslint-disable-next-line no-bitwise
  const r = processValue((num >> 16) + amount)
  // eslint-disable-next-line no-bitwise
  const b = processValue(((num >> 8) & 0x00ff) + amount)
  // eslint-disable-next-line no-bitwise
  const g = processValue((num & 0x0000ff) + amount)
  // eslint-disable-next-line no-bitwise
  return (usePound ? `#` : ``) + (g | (b << 8) | (r << 16)).toString(16)
}

export const lightenColor = (colorCode: string, amount: number) => lightenDarkenColor(colorCode, amount)
export const darkenColor = (colorCode: string, amount: number) => lightenDarkenColor(colorCode, amount * -1)
